export const VIRTUAL_PROPS_ACCESSOR = 'vProps';
export const VIRTUAL_PROPS_DB_COL_NAME = 'vPropsData';